import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import './LoginPage.css';

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const auth = getAuth();

  const handleLogin = (e) => {
    e.preventDefault(); // Prevent form submission from reloading the page
    if (!email || !password) {
      setMessage('Please enter both email and password.');
      return;
    }
    signInWithEmailAndPassword(auth, email, password)
      .then(() => {
        setMessage('');
        navigate('/mentorai');
      })
      .catch((error) => {
        switch (error.code) {
          case 'auth/user-not-found':
            setMessage('No user found with this email.');
            break;
          case 'auth/wrong-password':
            setMessage('Incorrect password. Please try again.');
            break;
          case 'auth/invalid-credential':
            setMessage('Invalid credentials. Please check your email and password.');
            break;
          default:
            setMessage(`Login failed: ${error.message}`);
            break;
        }
      });
  };

  return (
    <div className="login-page">
      <header className="header">
        <div className="contact-info">
          For any queries, contact us at <a href="mailto:contact@coursehubofficial.com">contact@coursehubofficial.com</a>
        </div>
        <div className="top-links">
          <a href="about.html">About</a>
          <a href="info.html">Info</a>
          <a href="services.html">Services</a>
          <a href="plans.html">Plans</a>
        </div>
      </header>

      <main className="main-container">
        <div className="content-wrapper">
          <div className="hero-section">
            <div className="logo">CourseHub</div>
            <h1>Unlock Your Next Level of Growth.</h1>
            <p>Our Mission: To uplift your business, career and life.</p>
            <p>CourseHub is the AI business coach that analyzes your company's data to provide a personalized strategy for success.</p>
          </div>

          <div className="auth-section">
            <form onSubmit={handleLogin}>
              <input
                className="login-input"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                className="login-input"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <div
                className="forgot-password"
                onClick={() => alert('Forgot password clicked')}
              >
                Forgot Password?
              </div>
              {message && <div className="error-message">{message}</div>}
              <button type="submit" className="login-button">Log In</button>
              <button type="button" className="register-button" onClick={() => navigate('/register')}>Register</button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
}

export default LoginPage;